import React, { useEffect, useState } from 'react';
import { Button, Card, CardBody, Col, Input, Row, Table } from 'reactstrap';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { toast } from "react-toastify";
import _ from 'lodash';
import { BomLookup, BOMTypeahead, Pager } from ".";
import { DesktopContainer } from '../layouts';
import { api, constants } from '../utils';

export default function WhereUsed(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [item, setItem] = useState(() => {
    const item = localStorage.getItem("itemNumber");
    const initialValue = JSON.parse(item);
    return initialValue || "";
  })
  const [page, setPage] = useState({ number: 1, size: 25 })
  const [screenOptions, setScreenOptions] = useState({ showDiscontinued: false })
  const [selectedItem, setSelectedItem] = useState(location.state);
  const [showBomList, setShowBomList] = useState(false);
  const [showWhereUsed, setShowWhereUsed] = useState(true);
  const [total, setTotal] = useState(0);

  useEffect(refreshData, [selectedItem, page, screenOptions])

  useEffect(() => {
    if (!location.state && !selectedItem && item) {
      setSelectedItem(item);
      setPage({...page, number: 1});
    }
    if (location.state !== selectedItem) {
      setSelectedItem(location.state);
      setPage({ ...page, number: 1 });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  function handleTypeahead(opt) {
    if (_.isNil(opt)) {
      setData([]);
    }
    setItem("");
    localStorage.removeItem("itemNumber");
    navigate(constants.ENDPOINTS.whereUsed, { state: opt, replace: true });
  }

  function refreshData() {
    document.title = `Where Used`;
    if (_.isNil(selectedItem)) return;
    // setWorking(true);
    api
      .post("Inventory/GetPaginatedWhereUsed", {
        itemNumber: selectedItem.value,
        showDiscontinued: screenOptions.showDiscontinued,
        pageNumber: page.number,
        pageSize: page.size
      })
      .then((r) => {
        if (r.data.success) {
          setData(r.data.whereUsed.items);
          setTotal(r.data.whereUsed?.totalCount);
        } else {
          toast.error("Error fetching where used items");
          console.error(r.data.message);
        }
      })
      .catch(api.catchHandler);
      // .finally(() => setWorking(false));
  }

  return (
    <DesktopContainer screenName="Where Used">
      <div className="filter-header sticky-top">
        <div className="dashboard-button-container">
          <Button
            children={"Where Used"}
            className="filter-button"
            onClick={() => setShowWhereUsed(!showWhereUsed)}
            active={showWhereUsed}
          />
          <Button
            children={"Item BOMs"}
            className="filter-button"
            onClick={() => setShowBomList(!showBomList)}
            active={showBomList}
          />
        </div>
      </div>

      {showWhereUsed ? (
        <Card className="dashboard-card">
          <CardBody>
            <div>
              <span className="h2 me-2">Where Used</span>{" "}
            </div>
            <hr />
            <div>
              <Row className="align-items-center" style={{ paddingBottom: "30px" }}>
                <Col xs={2} className="text-end">
                  <span className="h5">Item:</span>
                </Col>
                <Col xs={6}>
                  <BOMTypeahead
                    value={selectedItem}
                    onChange={opt => handleTypeahead(opt)}
                    itemGroup={constants.BOM_GROUP.Undefined}
                    includeSamples={true}
                  />
                </Col>
                <Col xs={4}>
                  <Input
                    type="checkbox"
                    className="me-3"
                    checked={screenOptions.showDiscontinued}
                    onChange={e => setScreenOptions({ ...screenOptions, showDiscontinued: e.target.checked })}
                  />
                  Show Discontinued Items
                </Col>
              </Row>
            </div>
            
            {data && data.length
              ? <div className="w-75 mx-auto">
                <Table size="sm" className="data-table">
                  <thead className="table-header">
                    <tr>
                      <th widht="80%" className="ps-2">Item</th>
                      <th width="10%"></th>
                      <th width="10%"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {_.map(data, (c, i) =>
                      <tr key={c.itemNumber} className={`tr-${i % 2 === 0 ? "primary" : "secondary"}`}>
                        <td className="ps-2">{c.itemWithDesc}</td>
                        <td>
                          <span className="boldedOrange nav-link" onClick={() => navigate(constants.ENDPOINTS.bomComponents, { state: {label: c.itemWithDesc, value: c.itemNumber} })}>
                            View BOM
                          </span>
                        </td>
                        <td>
                          {/* <span className={"boldedOrange nav-link"} onClick={() => navigate(constants.ENDPOINTS.whereUsed, { state: { label: c.itemWithDesc, value: c.itemNumber }, replace: true })}>
                            Show Where Used
                          </span> */}
                          <Link
                          className="shredLink fw-bold"
                          to={constants.ENDPOINTS.whereUsed}
                          onClick={() => localStorage.setItem("itemNumber", JSON.stringify({
                            label: c.itemWithDesc,
                            value: c.itemNumber
                          }))}
                          target="_blank"
                          style={{textDecoration: "none"}}
                          >
                            Show Where Used
                          </Link>
                        </td>
                      </tr>
                    )}
                  </tbody>
                  <tfoot className="table-footer">
                    <tr>
                      <td colSpan="3" />
                    </tr>
                  </tfoot>
                </Table>
                <Pager
                  callBack={number => setPage({ ...page, number: number })}
                  sizeCallback={size => setPage({ ...page, size: size })}
                  pageNumber={page.number}
                  pageSize={page.size}
                  totalPages={_.ceil(total / page.size)}
                  className={"float-start justify-content-center"}
                />
              </div>
            : <Row><Col className="text-center"><span className="h5">No Where Used Info Found</span></Col></Row>}
          </CardBody>
        </Card>
      ) : (
        false
      )}

      {showBomList ? (
        <Card className="dashboard-card">
          <CardBody>
            <div>
              <span className="h2 me-2">Item Bills of Materials</span>
            </div>
            <hr />
            <BomLookup />
          </CardBody>
        </Card>
      ) : (
        false
      )}

    </DesktopContainer>
  );
}